import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import coverageVerificationAnalyticService from '../../../services/coverage-verification-analytics.service';

const ActiveProvidersThisWeek = ({ filters }) => {
  const [mostActiveProvidersThisWeek, setMostActiveProvidersThisWeek] =
    useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getMostActiveProvidersThisWeek = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await coverageVerificationAnalyticService.getMostActiveProvidersThisWeek(
            {
              ...filters,
            },
          );
        setMostActiveProvidersThisWeek(
          data?.top_active_providers_this_week || [],
        );
      } catch (err) {
        console.error('Error fetching most active providers this week:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getMostActiveProvidersThisWeek();
  }, [filters]);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load most active providers details.
      </div>
    );
  }

  if (mostActiveProvidersThisWeek.length === 0) {
    return (
      <div className="text-muted text-center fw-semibold">
        No provider verification activity this week.
      </div>
    );
  }

  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '45%',
        distributed: true,
      },
    },
    colors: [
      '#6366f1',
      '#8b5cf6',
      '#a855f7',
      '#d946ef',
      '#ec4899',
      '#f43f5e',
      '#fb7185',
      '#f97316',
    ],
    dataLabels: { enabled: false },
    xaxis: {
      categories: mostActiveProvidersThisWeek.map((user) => user.name),
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
        },
        rotate: -45,
        trim: true,
      },
    },
    yaxis: {
      labels: { style: { colors: '#6b7280' } },
    },
    tooltip: {
      y: { formatter: (val) => `${val} verifications` },
    },
    grid: {
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
    },
  };

  const series = [
    {
      name: 'Verifications',
      data: mostActiveProvidersThisWeek.map((user) => user.verification_count),
    },
  ];

  return (
    <Chart options={chartOptions} series={series} type="bar" height={300} />
  );
};

export default ActiveProvidersThisWeek;
